var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{class:_vm.$style.overlay,attrs:{"close-on-click-overlay":"false"},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{class:_vm.$style.img,style:({
      backgroundImage: ("url('" + (_vm.SuccessOverlayImgInfo[_vm.packageType].img) + "')"),
      width: ((_vm.vm(_vm.SuccessOverlayImgInfo[_vm.packageType].width)) + "px"),
      height: ((_vm.vm(_vm.SuccessOverlayImgInfo[_vm.packageType].height)) + "px"),
    })},[_c('span',{class:_vm.$style['count-down']},[_vm._v("权益使用中 "+_vm._s(_vm.time)+"s")])])])}
var staticRenderFns = []

export { render, staticRenderFns }